<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card" v-if="$gate.isAllowed('is_pelanggan')">
                        <div class="card-header">
                            <h3 class="card-title">Daftar Pelanggan Internet NON AKTIF</h3>
                            <div class="card-tools">
                            </div>
                        </div>
                        <v-app>
                            <v-main>
                                <div class="card-body">
                                    <ul class="nav nav-tabs custom-tabs" id="custom-content-above-tab" role="tablist">
                                        <li class="nav-item">
                                            <a class="nav-link active" id="custom-content-above-home-tab"
                                                data-toggle="pill" href="#custom-content-above-home" role="tab"
                                                aria-controls="custom-content-above-home" aria-selected="true">
                                                <i class="fa fa-user-alt"></i>
                                                <span>PPPOE</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" id="custom-content-above-profile-tab" data-toggle="pill"
                                                href="#custom-content-above-profile" role="tab"
                                                aria-controls="custom-content-above-profile" aria-selected="false">
                                                <i class="fa fa-users"></i>
                                                <span>CORPORATE</span>
                                            </a>
                                        </li>
                                    </ul><br>

                                    <div class="tab-content" id="custom-content-above-tabContent">
                                        <div class="tab-pane fade show active" id="custom-content-above-home"
                                            role="tabpanel" aria-labelledby="custom-content-above-home-tab">
                                            <p style="margin: 2px 0; font-size: 14px;">Total Pelanggan Non-Aktif: <strong>{{
												datas.length }}</strong></p>
											<p style="margin: 2px 0; font-size: 14px;">Total Nilai Kontrak: <strong
													style="color: green; font-size: 18px;">{{ parseInt(ttl_data_pppoe) |
														toCurrency }}</strong></p>
                                            <template>
                                                <div class="container">
                                                    <div class="row">
                                                        <div class="col-md-6" style="padding-left:0px !important">
                                                            <!-- Filter Nama -->
                                                            <div class="row col-sm-12"
                                                                style="padding-bottom: 0 !important;">

                                                                <label for="nama" class="col-form-label">Cari Nama
                                                                    Pelanggan</label>
                                                                <input type="text" class="form-control"
                                                                    v-model="filters.nama"
                                                                    placeholder="Cari nama pelanggan / ID Pelanggan" />
                                                            </div>
                                                            <!-- Filter Kantor -->
                                                            <div class="row  col-sm-12"
                                                                style="padding-top: 0 !important;">
                                                                <label for="kantor" class="col-form-label">Pilih Kantor
                                                                    Cabang</label>
                                                                <select class="form-control" v-model="filters.kantor_id">
                                                                    <option value="">Semua Kantor</option>
                                                                    <option v-for="kantor in listKantor"
                                                                        :key="kantor.id" :value="kantor.id">
                                                                        {{ kantor.value }}
                                                                    </option>
                                                                </select>
                                                            </div>

                                                        </div>
                                                        <div class="col-md-6">
                                                            <!-- Filter Paket -->
                                                            <div class="row  col-sm-12">
                                                                <label for="paket" class="col-form-label">Pilih
                                                                    Paket</label>
                                                                <select class="form-control" v-model="filters.paket_id">
                                                                    <option value="">Semua Paket</option>
                                                                    <option v-for="paket in listPaket" :key="paket.id"
                                                                        :value="paket.id">
                                                                        {{ paket.value }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                            <!-- Tombol Cari -->
                                                            <div class="row  col-sm-12 "
                                                                style="margin-top: 20px !important;">
                                                                <button class="btn btn-primary w-50 me-1"
                                                                    @click="applyFilter">Cari</button>
                                                                <button class="btn btn-secondary w-40"
                                                                    @click="clearFilter">Reset</button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </template>

                                            <v-data-table @update:group-desc="cobaEvent" :headers="headers"
                                                :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100, -1] }"
                                                :items="datas" :items-per-page="25" item-key="id" sort-by="noRows"
                                                class="elevation-1 " show-group-by :search="cari_dt_plg">

                                                <template
                                                    v-slot:group.header="{ group, headers, toggle, isOpen, remove }">
                                                    <td :colspan="headers.length - 1">
                                                        <v-btn @click="toggle" x-small icon :ref="group">
                                                            <v-icon v-if="isOpen">mdi-minus</v-icon>
                                                            <v-icon v-else>mdi-plus</v-icon>
                                                        </v-btn>
                                                        <span class="mx-3"> Pengenal Pelanggan :
                                                            <span class="font-weight-bold"> {{ group }}</span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <v-btn @click="remove" x-small icon class="">
                                                            <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </template>

                                                <template v-slot:item.noRows="{ item }">
                                                    {{ datas.indexOf(item) + 1 }}
                                                </template>

                                                <template v-slot:item.pelanggan_id="{ item }">
                                                    {{ item.pelanggan_id }}

                                                    <a href="#" @click="editKTPModal(item.pelanggan_id, item.id)"
                                                        class="ml-1" title="Edit KTP">
                                                        <i class="fas fa-edit text-blue"></i>
                                                    </a>
                                                </template>

                                                <template v-slot:item.interval="{ item }">
                                                    <span>{{ $getMonthInterval(item.expired) }}</span>
                                                </template>

                                                <template v-slot:item.paket.harga="{ item }">
                                                    <div class="text-right font-weight-bold">
                                                        {{
                                                            (
                                                                (parseFloat(item.paket.harga) +
                                                                    Math.round(parseFloat(item.paket.harga * item.ppn / 100))) -
                                                                Math.round(((parseFloat(item.paket.harga) +
                                                                    parseFloat(item.paket.harga * item.ppn / 100)) *
                                                                    parseFloat(item.diskon / 100)))
                                                        ) | toCurrency
                                                        }}
                                                    </div>
                                                </template>

                                                <template v-slot:item.actions="{ item }">
                                                    <div class="tanpawrap">
                                                        <button class="btn btn-xs btn-primary"
                                                            title="Aktifkan Pelanggan"
                                                            @click="aktifkanPengguna(item.id)">
                                                            <i class="fas fa-check"></i>
                                                        </button>

                                                        <button class="btn btn-xs btn-secondary"
                                                            @click="buatInvoiceManualModal(item)"
                                                            title="Create Invoice Manual">
                                                            <i class="far fa-calendar-plus"></i>
                                                        </button>

                                                        <button class="btn btn-xs btn-info" @click="editModal(item)"
                                                            title="Lihat Data">
                                                            <i class="fa fa-eye"></i>
                                                        </button>

                                                        <button class="btn btn-xs btn-danger"
                                                            @click="deleteProduct(item.id)" title="Hapus data">
                                                            <i class="fas fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </template>

                                                <template v-slot:no-data>
                                                    <h6>Data Tidak Ditemukan</h6>
                                                </template>

                                            </v-data-table>
                                        </div>

                                        <div class="tab-pane fade" id="custom-content-above-profile" role="tabpanel"
                                            aria-labelledby="custom-content-above-profile-tab">
                                            <v-text-field v-model="cari_dt_plg_corp" label="Cari"
                                                class="w-100 col-md-2 ml-auto mb-2" outlined dense hide-details>
                                            </v-text-field>

                                            <v-data-table @update:group-desc="cobaEventCorp" :headers="headers"
                                                :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100, -1] }"
                                                :items="datas_corp" :items-per-page="25" item-key="id" sort-by="noRows"
                                                class="elevation-1 " show-group-by :search="cari_dt_plg_corp">

                                                <template
                                                    v-slot:group.header="{ group, headers, toggle, isOpen, remove }">
                                                    <td :colspan="headers.length - 1">
                                                        <v-btn @click="toggle" x-small icon :ref="group">
                                                            <v-icon v-if="isOpen">mdi-minus</v-icon>
                                                            <v-icon v-else>mdi-plus</v-icon>
                                                        </v-btn>
                                                        <span class="mx-3"> Pengenal Pelanggan : <span
                                                                class="font-weight-bold"> {{ group }}</span></span>
                                                    </td>
                                                    <td>
                                                        <v-btn @click="remove" x-small icon class="">
                                                            <v-icon>mdi-close</v-icon>
                                                        </v-btn>
                                                    </td>
                                                </template>

                                                <template v-slot:item.noRows="{ item }">
                                                    {{ datas_corp.indexOf(item) + 1 }}
                                                </template>

                                                <template v-slot:item.status="{ item }">
                                                    <div class="tanpawrap">
                                                        <a href="#" class="mr-1 ml-1" title="Aktifkan Pelanggan"
                                                            @click="aktifkanPengguna(item.id)">
                                                            <i class="fas fa-check text-green"></i>
                                                        </a>
                                                    </div>
                                                </template>

                                                <template v-slot:item.interval="{ item }">
                                                    <span>{{ $getMonthInterval(item.expired) }}</span>
                                                </template>

                                                <template v-slot:item.paket.harga="{ item }">
                                                    <div class="text-right font-weight-bold">
                                                        {{ ((parseFloat(item.paket.harga) +
                                                            Math.round(parseFloat(item.paket.harga * item.ppn / 100))) -
                                                            Math.round(((parseFloat(item.paket.harga) +
                                                        parseFloat(item.paket.harga*item.ppn/100)) *
                                                        parseFloat(item.diskon/100))) ) | toCurrency}}
                                                    </div>
                                                </template>

                                                <template v-slot:item.actions="{ item }">
                                                    <div class="tanpawrap">
                                                        <button class="btn btn-xs btn-secondary"
                                                            @click="buatInvoiceManualModal(item)"
                                                            title="Create Invoice Manual">
                                                            <i class="far fa-calendar-plus"></i>
                                                        </button>

                                                        <button class="btn btn-xs btn-info" @click="editModal(item)"
                                                            title="Lihat Data">
                                                            <i class="fa fa-eye"></i>
                                                        </button>
                                                        <button class="btn btn-xs btn-danger"
                                                            @click="deleteProduct(item.id)" title="Hapus data">
                                                            <i class="fas fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </template>

                                                <template v-slot:no-data>
                                                    <h6>Data Tidak Ditemukan</h6>
                                                </template>
                                            </v-data-table>
                                        </div>
                                    </div>

                                </div>
                            </v-main>
                        </v-app>
                        <div class="card-footer">
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!$gate.isAllowed('is_pelanggan')">
                <not-found></not-found>
            </div>

            <!-- Modal -->
            <div class="modal fade " id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true"
                data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" v-show="!editmode">Create New Pelanggan</h5>
                            <h5 class="modal-title" v-show="editmode"> Lihat Data Pelanggan</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form @submit.prevent="editmode ? updateProduct() : createProduct()"
                            enctype="multipart/form-data" id="formnya">
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="card card-outline card-primary">
                                            <div class="card-header">
                                                <h3 class="card-title" style="margin:0px">Data Pelanggan / Penanggung
                                                    Jawab</h3>
                                            </div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>No KTP</label>
                                                            <input v-model="form.plg.id" type="number" name="plg.id"
                                                                class="form-control"
                                                                :class="{ 'is-invalid': adaeror['plg.id'] || form.KTPAda }"
                                                                @blur="CariKTP"
                                                                @keydown="editmode ? '' : preventArrow($event)"
                                                                :disabled="editmode">
                                                            <small v-if="adaeror['plg.id']" class="text-danger">
                                                                {{ adaeror["plg.id"].join(', ') }}
                                                            </small>
                                                            <small v-if="form.KTPAda"
                                                                class="error invalid-feedback text-success">Data
                                                                Pelanggan
                                                                Ditemukan
                                                            </small>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Nama </label>
                                                            <input v-model="form.plg.nama" type="text" name="plg.nama"
                                                                class="form-control"
                                                                :class="{ 'is-invalid': adaeror['plg.nama'] }"
                                                                :disabled="disable_plg || (editmode && !bolehedit)">
                                                            <small v-if="adaeror['plg.nama']" class="text-danger">
                                                                {{ adaeror["plg.nama"].join(', ') }}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Email</label>
                                                            <input v-model="form.plg.email" type="text" name="plg.email"
                                                                class="form-control"
                                                                :class="{ 'is-invalid': adaeror['plg.email'] }"
                                                                :disabled="disable_plg || (editmode && !bolehedit)">
                                                            <small v-if="adaeror['plg.email']" class="text-danger">
                                                                {{ adaeror["plg.email"].join(', ') }}
                                                            </small>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>HP</label>
                                                            <input v-model="form.plg.hp" type="text" name="plg.hp"
                                                                class="form-control"
                                                                :class="{ 'is-invalid': adaeror['plg.hp'] }"
                                                                :disabled="disable_plg || (editmode && !bolehedit)">
                                                            <small v-if="adaeror['plg.hp']" class="text-danger">
                                                                {{ adaeror["plg.hp"].join(', ') }}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Provinsi (sesuai KTP)</label>
                                                            <select v-model="form.plg.provinsi_id"
                                                                name="plg.provinsi_id" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['plg.provinsi_id'] }"
                                                                :disabled="disable_plg || (editmode && !bolehedit)">
                                                                <option v-bind:value="1">Aceh</option>
                                                            </select>
                                                            <small v-if="adaeror['plg.provinsi_id']"
                                                                class="text-danger">
                                                                {{ adaeror["plg.provinsi_id"].join(', ') }}
                                                            </small>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Kabupaten (sesuai KTP)</label>
                                                            <select class="form-control"
                                                                v-model.lazy="form.plg.kabupaten_id"
                                                                :class="{ 'is-invalid': adaeror['plg.kabupaten_id'] }"
                                                                :disabled="disable_plg || (editmode && !bolehedit)"
                                                                @change="loadKecamatanTT">
                                                                <option selected disabled value="">Pilih...
                                                                </option>
                                                                <option v-for="(value) in kabupatensTT" :key="value.id"
                                                                    :value="value.id">{{ value.value }}</option>
                                                            </select>
                                                            <small v-if="adaeror['plg.kabupaten_id']"
                                                                class="text-danger">
                                                                {{ adaeror["plg.kabupaten_id"].join(', ') }}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Kecamatan (sesuai KTP)</label>
                                                            <select class="form-control" v-model="form.plg.kecamatan_id"
                                                                :class="{ 'is-invalid': adaeror['plg.kecamatan_id'] }"
                                                                :disabled="disable_plg || (editmode && !bolehedit)">
                                                                <option selected disabled value="">Pilih...
                                                                </option>
                                                                <option v-for="(value) in kecamatanTT" :key="value.id"
                                                                    :value="value.id">{{ value.value }}</option>
                                                            </select>
                                                            <small v-if="adaeror['plg.kecamatan_id']"
                                                                class="text-danger">
                                                                {{ adaeror["plg.kecamatan_id"].join(', ') }}
                                                            </small>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Alamat (Detail Sesuai KTP)</label>
                                                            <textarea v-model="form.plg.alamat" name="plg.alamat"
                                                                class="form-control" style="resize:none;"
                                                                :class="{ 'is-invalid': adaeror['plg.alamat'] }"
                                                                :disabled="disable_plg || (editmode && !bolehedit)"></textarea>
                                                            <small v-if="adaeror['plg.alamat']" class="text-danger">
                                                                {{ adaeror["plg.alamat"].join(', ') }}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Upload KTP</label>
                                                            <div class="custom-file">
                                                                <input type="file" id="file" name="file"
                                                                    class="custom-file-input" @change="onUploadKTP"
                                                                    :class="{ 'is-invalid': adaeror['file'] }"
                                                                    :disabled="disable_plg || (editmode && !bolehedit)"
                                                                    accept="image/*">
                                                                <label class="custom-file-label" for="file">{{ filename
                                                                    ?
                                                                    filename :
                                                                    'Choose File'}}</label>
                                                                <small v-if="adaeror['file']" class="text-danger">
                                                                    {{ adaeror["file"].join(', ') }}
                                                                </small>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <img :src="'./' + urlFotoKtp"
                                                            v-if="urlFotoKtp && !urlFotoKtpPreview"
                                                            style="width: 300px; height: 150px; max-width: 300px; max-height: 150px;">
                                                        <img :src="urlFotoKtp" v-if="urlFotoKtpPreview"
                                                            style="width: 300px; height: 150px; max-width: 300px; max-height: 150px;">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="card card-outline card-success">
                                            <div class="card-header">
                                                <h3 class="card-title" style="margin:0px">Data Internet</h3>
                                                <div class="card-tools">
                                                    <label>Lewati </label>
                                                    &nbsp;
                                                    <label class="switch">
                                                        <input type="checkbox" v-model="form.showInternet"
                                                            :disabled="editmode">
                                                        <span class="slider"></span>
                                                    </label>
                                                    &nbsp;
                                                    <label> Isi </label>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Nama Tempat Instalasi</label>
                                                            <input v-model="form.inet.nama" type="text" name="inet.nama"
                                                                class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.nama'] }"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                            <small v-if="adaeror['inet.nama']" class="text-danger">
                                                                {{ adaeror["inet.nama"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.nama"></has-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                    </div>
                                                </div>
                                                <br />
                                                <h5>Alamat Instalasi</h5>
                                                <hr style="border:1px solid;" />
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Provinsi</label>
                                                            <select v-model="form.inet.provinsi_id"
                                                                name="inet.provinsi_id" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.provinsi_id'] }"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                                <option v-bind:value="1">Aceh</option>
                                                            </select>
                                                            <small v-if="adaeror['inet.provinsi_id']"
                                                                class="text-danger">
                                                                {{ adaeror["inet.provinsi_id"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.provinsi_id">
                                                            </has-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Kabupaten</label>
                                                            <select class="form-control"
                                                                v-model.lazy="form.inet.kabupaten_id"
                                                                :class="{ 'is-invalid': adaeror['inet.kabupaten_id'] }"
                                                                @change="loadKecamatanTI"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                                <option selected disabled value="">Pilih...
                                                                </option>
                                                                <option v-for="(val) in kabupatensTT" :key="val.id"
                                                                    :value="val.id">
                                                                    {{ val.value }}</option>
                                                            </select>
                                                            <small v-if="adaeror['inet.kabupaten_id']"
                                                                class="text-danger">
                                                                {{ adaeror["inet.kabupaten_id"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.kabupaten_id">
                                                            </has-error>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Kecamatan</label>
                                                            <select class="form-control"
                                                                v-model="form.inet.kecamatan_id"
                                                                :class="{ 'is-invalid': adaeror['inet.kecamatan_id'] }"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                                <option selected disabled value="">Pilih...
                                                                </option>
                                                                <option v-for="(value) in kecamatanTI" :key="value.id"
                                                                    :value="value.id">{{ value.value }}</option>
                                                            </select>
                                                            <small v-if="adaeror['inet.kecamatan_id']"
                                                                class="text-danger">
                                                                {{ adaeror["inet.kecamatan_id"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form"
                                                                field="inet.kecamatan_id"></has-error>

                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Alamat Detail Instalasi</label>
                                                            <textarea v-model="form.inet.alamat" name="inet.alamat"
                                                                class="form-control" style="resize:none;"
                                                                :class="{ 'is-invalid': adaeror['inet.alamat'] }"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))"></textarea>
                                                            <small v-if="adaeror['inet.alamat']" class="text-danger">
                                                                {{ adaeror["inet.alamat"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.alamat"></has-error>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Latitude</label>
                                                            <input v-model="form.inet.latitude" type="text"
                                                                name="inet.latitude" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.latitude'] }"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                            <small v-if="adaeror['inet.latitude']" class="text-danger">
                                                                {{ adaeror["inet.latitude"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.latitude"></has-error>
                                                        </div>

                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Longitude</label>
                                                            <input v-model="form.inet.longitude" type="text"
                                                                name="inet.longitude" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.longitude'] }"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                            <small v-if="adaeror['inet.longitude']" class="text-danger">
                                                                {{ adaeror["inet.longitude"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.longitude"></has-error>
                                                        </div>

                                                    </div>
                                                </div>
                                                <br />
                                                <h5>Config Instalasi</h5>
                                                <hr style="border:1px solid;" />
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Tipe Langganan</label>
                                                            <select v-model="form.inet.tipe_langganan"
                                                                name="inet.tipe_langganan" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.tipe_langganan'] }"
                                                                :disabled="(!form.showInternet || editmode)"
                                                                @change="doLoadPaket">
                                                                <!-- inline object literal -->
                                                                <option selected disabled value="">Pilih...
                                                                </option>
                                                                <option :key="1" :value="1">PPPOE</option>
                                                                <option :key="2" :value="2">Corporate</option>
                                                            </select>
                                                            <small v-if="adaeror['inet.tipe_langganan']"
                                                                class="text-danger">
                                                                {{ adaeror["inet.tipe_langganan"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form"
                                                                field="inet.tipe_langganan"></has-error>
                                                        </div>

                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Router</label>
                                                            <select class="form-control" v-model="form.inet.router_id"
                                                                name="inet.router_id"
                                                                :class="{ 'is-invalid': adaeror['inet.router_id'] }"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                                <option selected disabled value="">Pilih...
                                                                </option>
                                                                <option v-for="(nama, cat, index) in routers"
                                                                    :key="index" :value="index">{{ cat }} - {{ nama }}
                                                                </option>
                                                            </select>
                                                            <small v-if="adaeror['inet.router_id']" class="text-danger">
                                                                {{ adaeror["inet.router_id"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.router_id"></has-error>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">

                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>IP Address </label>
                                                            <label class="switch">
                                                                <input type="checkbox" v-model="form.poolon"
                                                                    @change="reset_pool"
                                                                    :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                                <span class="slider"></span>
                                                            </label>
                                                            <label>Group Pool </label>
                                                            <input v-show="!form.poolon" v-model="form.inet.ip_address"
                                                                type="text" name="inet.ip_address" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.ip_address'] }"
                                                                :disabled="form.poolon || !form.showInternet || (editmode && !bolehedit)">
                                                            <small v-if="adaeror['inet.ip_address']"
                                                                class="text-danger">
                                                                {{ adaeror["inet.ip_address"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.ip_address"></has-error>
                                                            <select v-show="form.poolon" class="form-control"
                                                                v-model="form.inet.pool_id" name="inet.pool_id"
                                                                :class="{ 'is-invalid': adaeror['inet.pool_id'] }"
                                                                :disabled="!form.poolon || !form.showInternet || (editmode && !bolehedit)">
                                                                <option selected disabled value="">Pilih...
                                                                </option>
                                                                <option v-for="(cat, index) in pools" :key="index"
                                                                    :value="index">{{
                                                                        cat }}</option>
                                                            </select>
                                                            <small v-if="adaeror['inet.pool_id']" class="text-danger">
                                                                {{ adaeror["inet.pool_id"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.pool_id"></has-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Kunci MAC Addr? <input type="checkbox"
                                                                    v-model="kunci_mac" name="kunci_mac"
                                                                    @change="reset_mac"
                                                                    :disabled="(!form.showInternet || (editmode && !bolehedit))"></label>
                                                            <input v-model="form.inet.mac_address" type="text"
                                                                name="inet.mac_address" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.mac_address'] }"
                                                                :disabled="!kunci_mac || !form.showInternet || (editmode && !bolehedit)">
                                                            <small v-if="adaeror['inet.mac_address']"
                                                                class="text-danger">
                                                                {{ adaeror["inet.mac_address"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form"
                                                                field="inet.mac_address"></has-error>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Username <span v-if="!editmode">(Pelanggan Lama ?
                                                                    <input type="checkbox" v-model="form.pelanggan_lama"
                                                                        name="form.pelanggan_lama"
                                                                        @change="reset_username"
                                                                        :disabled="!form.showInternet || editmode">)</span></label>
                                                            <input v-model="form.username" type="text"
                                                                placeholder="Skip untuk Generate Otomatis"
                                                                name="username" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['username'] }"
                                                                :disabled="!form.pelanggan_lama || (!form.showInternet || editmode)">
                                                            <small v-if="adaeror['username']" class="text-danger">
                                                                {{ adaeror["username"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="username"></has-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Password</label>
                                                            <input v-model="form.inet.password" type="text"
                                                                name="inet.password" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.password'] }"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                            <small v-if="adaeror['inet.password']" class="text-danger">
                                                                {{ adaeror["inet.password"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.password"></has-error>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Serial Number ONT</label>
                                                            <input v-model="form.inet.snont" type="text"
                                                                name="inet.snont" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.snont'] }"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                            <small v-if="adaeror['inet.snont']" class="text-danger">
                                                                {{ adaeror["inet.snont"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.snont"></has-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Tipe ONT</label>
                                                            <input v-model="form.inet.tipeont" type="text"
                                                                name="inet.tipeont" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.tipeont'] }"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                            <small v-if="adaeror['inet.tipeont']" class="text-danger">
                                                                {{ adaeror["inet.tipeont"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.tipeont"></has-error>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br />
                                                <h5>Data Billing Internet</h5>
                                                <hr style="border:1px solid;" />

                                                <!--div class="row" v-show="form.inet.tipe_langganan == '1'"-->
                                                <div class="row" v-show="false">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Tipe Billing</label>
                                                            <select v-model="form.inet.billing_tipe"
                                                                name="inet.billing_tipe" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.billing_tipe'] }"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                                <!-- inline object literal -->
                                                                <option v-bind:value="1" selected>Pascabayar</option>
                                                            </select>
                                                            <small v-if="adaeror['inet.billing_tipe']"
                                                                class="text-danger">
                                                                {{ adaeror["inet.billing_tipe"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form"
                                                                field="inet.billing_tipe"></has-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Billing Period</label>
                                                            <select v-model="form.inet.billing_period"
                                                                name="inet.billing_period" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.billing_period'] }"
                                                                @change="changeFixedBil"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                                <!-- inline object literal -->
                                                                <option selected disabled value="">Pilih...
                                                                </option>
                                                                <option v-bind:value="1">Profil Period</option>
                                                                <option v-bind:value="2">Fixed Period</option>
                                                            </select>
                                                            <small v-if="adaeror['inet.billing_period']"
                                                                class="text-danger">
                                                                {{ adaeror["inet.billing_period"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form"
                                                                field="inet.billing_period"></has-error>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!--div class="row"  v-show="form.inet.tipe_langganan == '1'"-->
                                                <div class="row" v-show="false">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <v-menu
                                                                :disabled="fixedBil || !form.showInternet || (editmode && !bolehedit)"
                                                                v-model="menu" :close-on-content-click="false"
                                                                :nudge-right="40" transition="scale-transition" offset-y
                                                                min-width="auto">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field
                                                                        :disabled="fixedBil || !form.showInternet || (editmode && !bolehedit)"
                                                                        v-model="form.inet.billing_mulai"
                                                                        label="Tanggal Aktif"
                                                                        prepend-icon="mdi-calendar" readonly
                                                                        v-bind="attrs" v-on="on"></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    :disabled="fixedBil || !form.showInternet || (editmode && !bolehedit)"
                                                                    v-model="form.inet.billing_mulai"
                                                                    @input="menu = false"></v-date-picker>
                                                            </v-menu>
                                                            <!--input v-model="form.inet.billing_mulai" type="text" name="inet.billing_mulai"
                                            class="form-control" :class="{ 'is-invalid': form.errors.has('inet.billing_mulai') }" -->
                                                            <small v-if="adaeror['inet.billing_mulai']"
                                                                class="text-danger">
                                                                {{ adaeror["inet.billing_mulai"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form"
                                                                field="inet.billing_mulai"></has-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <v-menu
                                                                :disabled="fixedBil || !form.showInternet || (editmode && !bolehedit)"
                                                                v-model="menu2" :close-on-content-click="false"
                                                                :nudge-right="40" transition="scale-transition" offset-y
                                                                min-width="auto">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field
                                                                        :disabled="fixedBil || !form.showInternet || (editmode && !bolehedit)"
                                                                        v-model="form.inet.billing_akhir"
                                                                        label="Tanggal Expired"
                                                                        prepend-icon="mdi-calendar" readonly
                                                                        v-bind="attrs" v-on="on"></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    :disabled="fixedBil || !form.showInternet || (editmode && !bolehedit)"
                                                                    v-model="form.inet.billing_akhir"
                                                                    @input="menu2 = false"></v-date-picker>
                                                            </v-menu>

                                                            <!--input v-model="form.inet.billing_akhir" type="text" name="inet.billing_akhir"
                                            class="form-control" :class="{ 'is-invalid': form.errors.has('inet.billing_akhir') }" -->
                                                            <small v-if="adaeror['inet.billing_akhir']"
                                                                class="text-danger">
                                                                {{ adaeror["inet.billing_akhir"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form"
                                                                field="inet.billing_akhir"></has-error>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Profil Internet</label>
                                                            <select class="form-control" v-model="form.inet.paket_id"
                                                                name="inet.paket_id"
                                                                :class="{ 'is-invalid': adaeror['inet.paket_id'] }"
                                                                @change="tarukHarga($event.target.value)"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))"
                                                                required>
                                                                <!--select class="form-control"  v-model="form.inet.paket_id" name="inet.paket_id" :class="{ 'is-invalid': adaeror['inet.paket_id'] }" @change="tarukHarga($event.target.value)" :disabled="(!form.showInternet || editmode)" required-->
                                                                <option selected disabled value="">Pilih...
                                                                </option>
                                                                <option v-for="(cat) in pakets" :key="cat.id"
                                                                    :value="cat.id">{{
                                                                        cat.value }}</option>
                                                            </select>
                                                            <small v-if="adaeror['inet.paket_id']" class="text-danger">
                                                                {{ adaeror["inet.paket_id"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.paket_id"></has-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Harga Profil</label>
                                                            <input v-model="harga" type="text" name="harga"
                                                                class="form-control"
                                                                :class="{ 'is-invalid': adaeror['harga'] }"
                                                                :disabled="true">
                                                            <small v-if="adaeror['harga']" class="text-danger">
                                                                {{ adaeror["harga"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="harga"></has-error>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-md-2">
                                                        <div class="form-group">
                                                            <label>PPN (%) </label>
                                                            <input v-model.number="form.inet.ppn" type="number"
                                                                step="any" name="inet.ppn" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.ppn'] }"
                                                                @keydown="preventArrow($event)" @change="setTotal"
                                                                min="0"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                            <span>(Potong? <input type="checkbox"
                                                                    v-model="form.inet.potong_ppn" name="potong_ppn"
                                                                    @change="setTotal"
                                                                    :disabled="form.inet.ppn < 1 || !form.showInternet || (editmode && !bolehedit)">)</span>
                                                            <small v-if="adaeror['inet.ppn']" class="text-danger">
                                                                {{ adaeror["inet.ppn"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.ppn"></has-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label>PPN Dalam Rp </label>
                                                            <input v-model.number="ppn_dlm_rp" type="number" step="any"
                                                                name="ppn_dlm_rp" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.ppn'] }"
                                                                :readonly="true">
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <div class="form-group">
                                                            <label>Diskon (%)</label>
                                                            <input v-model.number="form.inet.diskon" type="number"
                                                                step="any" name="inet.diskon" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.diskon'] }"
                                                                @keydown="preventArrow($event)" @change="setTotal"
                                                                min="0" max="100"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                            <small v-if="adaeror['inet.diskon']" class="text-danger">
                                                                {{ adaeror["inet.diskon"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.diskon"></has-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label>SLA (%)</label>
                                                            <input v-model.number="form.inet.sla" type="number"
                                                                name="inet.sla" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.sla'] }"
                                                                @keydown="preventArrow($event)" min="0" max="100"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                            <small v-if="adaeror['inet.sla']" class="text-danger">
                                                                {{ adaeror["inet.sla"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.sla"></has-error>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label>Dana Cashback </label>
                                                            <input v-model.number="form.inet.kickback" type="number"
                                                                name="inet.kickback" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.kickback'] }"
                                                                @keydown="preventArrow($event)" min="0"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                            <span>(Potong? <input type="checkbox"
                                                                    v-model="form.inet.potong_kickback"
                                                                    name="potong_kickback" @change="setTotal"
                                                                    :disabled="form.inet.kickback < 1 || !form.showInternet || (editmode && !bolehedit)">)</span>
                                                            <small v-if="adaeror['inet.kickback']" class="text-danger">
                                                                {{ adaeror["inet.kickback"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.kickback"></has-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label>PPH 23 </label>
                                                            <input v-model.number="form.inet.pph23" type="number"
                                                                name="inet.pph23" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.pph23'] }"
                                                                @keydown="preventArrow($event)" min="0"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                            <span>(Potong? <input type="checkbox"
                                                                    v-model="form.inet.potong_pph23" name="potong_pph23"
                                                                    @change="setTotal"
                                                                    :disabled="form.inet.pph23 < 1 || !form.showInternet || (editmode && !bolehedit)">)</span>
                                                            <small v-if="adaeror['pph23']" class="text-danger">
                                                                {{ adaeror["pph23"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="pph23"></has-error>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="form-group">
                                                            <label>Zakat </label>
                                                            <input v-model.number="form.inet.zakat" type="number"
                                                                name="inet.zakat" class="form-control"
                                                                :class="{ 'is-invalid': adaeror['inet.zakat'] }"
                                                                @keydown="preventArrow($event)" min="0"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                            <span>(Potong? <input type="checkbox"
                                                                    v-model="form.inet.potong_zakat" name="potong_zakat"
                                                                    @change="setTotal"
                                                                    :disabled="form.inet.zakat < 1 || !form.showInternet || (editmode && !bolehedit)">)</span>
                                                            <small v-if="adaeror['zakat']" class="text-danger">
                                                                {{ adaeror["zakat"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="zakat"></has-error>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <div class="form-group">
                                                            <label>TOTAL Bayar Bulanan</label>
                                                            <input v-model="total" type="text" name="total"
                                                                class="form-control"
                                                                :class="{ 'is-invalid': adaeror['total_checker'] }"
                                                                :disabled="true">
                                                            <small v-if="adaeror['total_checker']" class="text-danger">
                                                                {{ adaeror["total_checker"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="total"></has-error>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Kantor Pengawas (Saldo Invoice)</label>
                                                            <select class="form-control" v-model="form.inet.kantor_id"
                                                                :class="{ 'is-invalid': adaeror['inet.kantor_id'] }"
                                                                :disabled="(!form.showInternet || (editmode && !bolehedit))">
                                                                <option selected disabled value="">Pilih...
                                                                </option>
                                                                <option v-for="(value) in kantorList" :key="value.id"
                                                                    :value="value.id">{{ value.value }}</option>
                                                            </select>
                                                            <small v-if="adaeror['inet.kantor_id']" class="text-danger">
                                                                {{ adaeror["inet.kantor_id"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form" field="inet.kantor_id"></has-error>

                                                        </div>
                                                    </div>
                                                    <div class="col-md-6" v-show="form.inet.tipe_langganan == '1'">
                                                        <div class="form-group">
                                                            <label>Prioritas ? <input type="checkbox"
                                                                    v-model="form.inet.is_prioritas"
                                                                    name="form.inet.is_prioritas"
                                                                    :class="{ 'is-invalid': adaeror['inet.is_prioritas'] }"
                                                                    :disabled="disable_plg || (editmode && !bolehedit)">
                                                                &nbsp;
                                                                <span
                                                                    v-show="form.inet.is_prioritas == '1'">YA</span><span
                                                                    v-show="form.inet.is_prioritas != '1'">TIDAK</span></label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <br />
                                                <h5>Data Opsional</h5>
                                                <hr style="border:1px solid;" />
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Sales</label>
                                                            <select name="sales_id" v-model="form.inet.sales_id"
                                                                id="sales_id" class="form-control"
                                                                :class="{ 'is-invalid': form.errors.has('sales_id') }"
                                                                required>
                                                                <option value="" selected disabled>-- PILIH SALES --
                                                                </option>
                                                                <option v-for="sales in sales_list" :key="sales.idsales"
                                                                    :value="sales.idsales">{{ sales.nama }}</option>
                                                            </select>
                                                            <has-error :form="form" field="inet.sales_id"></has-error>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="form-group">
                                                            <label>Tanggal Berlangganan (Khusus Pelanggan Lama)</label>
                                                            <v-menu
                                                                :disabled="!form.pelanggan_lama || !form.showInternet || (editmode && !bolehedit)"
                                                                v-model="menu3" :close-on-content-click="false"
                                                                :nudge-right="40" transition="scale-transition" offset-y
                                                                min-width="auto">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-text-field style="margin-top:0px;padding-top:0px"
                                                                        :disabled="!form.pelanggan_lama || !form.showInternet || (editmode && !bolehedit)"
                                                                        v-model="form.inet.old_created_at" label=""
                                                                        prepend-icon="mdi-calendar" readonly
                                                                        v-bind="attrs" v-on="on"></v-text-field>
                                                                </template>
                                                                <v-date-picker
                                                                    :disabled="!form.pelanggan_lama || !form.showInternet || (editmode && !bolehedit)"
                                                                    v-model="form.inet.old_created_at"
                                                                    @input="menu3 = false"></v-date-picker>
                                                            </v-menu>

                                                            <small v-if="adaeror['inet.old_created_at']"
                                                                class="text-danger">
                                                                {{ adaeror["inet.old_created_at"].join(', ') }}
                                                            </small>
                                                            <has-error :form="form"
                                                                field="inet.old_created_at"></has-error>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- /.card-body -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button v-show="editmode" disabled="true" type="submit"
                                    class="btn btn-success">Update</button>
                                <button v-show="!editmode" type="submit" class="btn btn-primary">Tambah</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="editKTPModal" tabindex="-1" role="dialog" aria-labelledby="editKTPModal"
                aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title"> Edit KTP Pelanggan </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                @click="closeEKTP()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <!--form id="formEditKTP"-->
                        <form @submit.prevent="editNoKTP()" id="formEditKTP">
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-5">
                                        <label>No KTP LAMA</label>
                                        <input v-model="noktplama" type="text" name="noktplama" class="form-control"
                                            :readonly="true">
                                    </div>
                                    <div class="col-md-5">
                                        <label>No KTP BARU</label>
                                        <input v-model="noktpbaru" type="text" name="noktpbaru" class="form-control">
                                    </div>
                                    <div class="col-md-2">
                                        <label>Cari</label>
                                        <br>
                                        <a href="#" @click="CariKTP2()">
                                            <i class="fas fa-search"></i>
                                        </a>
                                    </div>
                                    <input v-model="noinet" type="hidden" name="noinet">
                                </div>

                                <div class="row" v-if="editKTPAda">
                                    <div class="col-md-12">
                                        Hasil Cari :
                                        <h5 class="text-red">Pelanggan Dengan Nomor KTP Baru Ini Ditemukan dengan Nama
                                            {{ editKTPAdaNama }}.</h5>

                                    </div>
                                </div>
                                <div class="row" v-else>
                                    Hasil Cari :
                                    <div class="col-md-12">
                                        -
                                    </div>
                                </div>
                                <br />
                                Yakin Untuk Merubah NO KTP Pelanggan ini ?

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                                    @click="closeEKTP()">Close</button>
                                <button type="submit" class="btn btn-success">Edit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="invoiceManualModal" tabindex="-1" role="dialog"
                aria-labelledby="invoiceManualModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title"> Buat Invoice Manual </h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                                @click="tutupInvoiceManualModal()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <!--form id="formEditKTP"-->
                        <form @submit.prevent="createInvoiceManual()" id="formBuatInvoiceManual">
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <label>No Internet Pelanggan</label>
                                        <input v-model="inv_no" type="text" name="inv_no" class="form-control"
                                            :readonly="true">
                                    </div>
                                    <div class="col-md-6">
                                        <label>Nama Tempat Instalasi</label>
                                        <input v-model="inv_nama" type="text" name="inv_nama" class="form-control"
                                            :readonly="true">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <label>Pilih Bulan Invoice</label>
                                        <v-dialog ref="dialog" v-model="inv_modaltgl"
                                            :return-value.sync="inv_tanggal_query" persistent width="290px"
                                            :retain-focus="false">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field style="margin-top:0px;padding-top:0px"
                                                    v-model="inv_tanggal_query" label="" prepend-icon="mdi-calendar"
                                                    readonly v-bind="attrs" v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="inv_tanggal_query" type="month" scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="inv_modaltgl = false">
                                                    Cancel
                                                </v-btn>
                                                <v-btn text color="primary" @click="ubahTanggalTampil($refs)">
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </div>
                                    <div class="col-md-4">
                                        <label>Value Bulan Invoice</label>
                                        <input v-model="inv_tanggal_tampil" type="text" name="inv_tanggal_tampil"
                                            class="form-control" :readonly="true">
                                    </div>
                                    <div class="col-md-4">
                                        <label>Tanggal Batas Bayar</label>
                                        <v-dialog ref="dialogs" v-model="inv_modaltgl_batas"
                                            :return-value.sync="inv_tanggal_batas" persistent width="290px"
                                            :retain-focus="false">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field style="margin-top:0px;padding-top:0px"
                                                    v-model="inv_tanggal_batas" label="" prepend-icon="mdi-calendar"
                                                    readonly v-bind="attrs" v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="inv_tanggal_batas" type="date" scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="inv_modaltgl_batas = false">
                                                    Cancel
                                                </v-btn>
                                                <v-btn text color="primary" @click="ubahTanggalTampill($refs)">
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </div>
                                </div>
                                <!--div class="row">
                            <div class="col-md-4">
                              <label>Tanggal Pakai Awal</label>
                              <input v-model="inv_tanggal_awal" type="text" name="inv_tanggal_inv_awal"
                                  class="form-control" :readonly="true">
                            </div>
                            <div class="col-md-4">
                              <label>Tanggal Pakai Akhir</label>
                              <input v-model="inv_tanggal_akhir" type="text" name="inv_tanggal_inv_akhir"
                                  class="form-control" :readonly="true">
                            </div>
                            <input v-model="noinet" type="hidden" name="noinet">
                            <div class="col-md-4">
                              <label>Tanggal Batas Bayar</label>
                              <input v-model="inv_tanggal_batas" type="text" name="inv_tanggal_inv_batas"
                                  class="form-control" :readonly="true">
                                
                            </div>
                          </div-->
                                <small><strong>*</strong> Tagihan akan masuk ke <span class="text-red">OVERDUE</span>
                                    jika TANGGAL
                                    BATAS BAYAR sudah terlewati</small>
                                <br />
                                <small><strong>**</strong> Pembuatan Invoice Akan gagal jika pada bulan terpilih Invoice
                                    Pelanggan
                                    sudah ada</small>
                                <br />
                                <br />
                                <h4>Yakin Untuk Membuat Invoice ini ?</h4>

                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal"
                                    @click="tutupInvoiceManualModal()">Close</button>
                                <button type="submit" class="btn btn-success">Buat!</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
import vSelect from 'vue-select';
import _ from 'lodash';
export default {
    components: {
        'v-select': vSelect
    },
    data() {
        return {
            user: this.$gate.user,
			loading: false,
			filters: {
				kantor_id: '',
				paket_id: '',
				nama: ''
			},
            listKantor: [],
			listPaket: [],
            inv_no: "",
            inv_nama: "",
            inv_modaltgl_batas: false,
            inv_modaltgl: false,
            inv_tanggal_query: new Date().toISOString().substr(0, 7),
            inv_tanggal_batas: new Date(new Date().setFullYear(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
            inv_tanggal_tampil: '',
            jlh_data_pppoe: '0',
            ttl_data_pppoe: '0',
            jlh_data_corpo: '0',
            ttl_data_corpo: '0',
            tampilan_kantor: '10000',
            noktplama: '',
            noktpbaru: '',
            noinet: '',
            editKTPAda: false,
            editKTPAdaNama: "",
            urlFotoKtp: '',
            urlFotoKtpPreview: false,
            table_group_state: false,
            fixedBil: true,
            menu3: false,
            menu2: false,
            menu: false,
            filename: '',
            file_ktp: '',
            cari_dt_plg_corp: '',
            cari_dt_plg: '',
            kunci_mac: false,
            editall: false,
            editpelanggan: false,
            editinternet: false,
            editmode: false,
            bolehedit: false,
            datas_corp: [],
            datas: [],
            kabupatensTT: {},
            kecamatanTT: {},
            kecamatanTI: {},
            kantorList: {},
            pools: {},
            pakets: {},
            routers: {},
            total: '0',
            harga: '',
            ppn_dlm_rp: '0',
            headers: [
                { text: 'No', value: 'noRows', sortable: true, groupable: false, },
                { text: 'Nama', value: 'pelanggan.nama', groupable: false, },
                { text: 'Aktivasi', value: 'active_at', groupable: false, },
                { text: 'Expired', value: 'expired', groupable: false, },
                { text: 'Interval', value: 'interval', groupable: false, },
                { text: 'Siklus', value: 'billing_cycle', groupable: false, },
                { text: 'Tmp Instalasi', value: 'nama', groupable: false, },
                { text: 'Nilai Kontrak', value: 'paket.harga', groupable: false, align: "end", class: "text-right" },
                { text: 'Aksi', value: 'actions', sortable: false, groupable: false, align: "center", class: "text-right" },
            ],

            form: new Form({
                plg: {
                    nama: '',
                    email: '',
                    hp: '',
                    provinsi_id: '1',
                    kabupaten_id: '',
                    kecamatan_id: '',
                    id: '',
                    alamat: '',
                },
                inet: {
                    nama: '',
                    provinsi_id: '1',
                    kabupaten_id: '',
                    kecamatan_id: '',
                    alamat: '',
                    latitude: '',
                    longitude: '',
                    tipe_langganan: '',
                    router_id: '',
                    pool_id: '',
                    service_id: '1',
                    ip_address: '',
                    mac_address: '',
                    id: '',
                    password: '',
                    snont: '',
                    tipeont: '',
                    billing_tipe: '1',
                    billing_period: '2',
                    billing_mulai: '',
                    billing_akhir: '',
                    paket_id: '',
                    ppn: '0',
                    potong_ppn: false,
                    diskon: '0',
                    sla: '0',
                    pph23: '0',
                    potong_pph23: false,
                    zakat: '0',
                    potong_zakat: false,
                    kickback: '0',
                    potong_kickback: false,
                    invited_by: '',
                    sales_id: '',
                    old_created_at: '',
                    is_prioritas: '',
                    kantor_id: '',
                },
                total_checker: '0',
                poolon: false,
                //  showBilling: false,
                showInternet: false,
                KTPAda: false,
                username: '',
                pelanggan_lama: false,
            }),
            pelanggans: [],
            pelanggans2: [],
            disable_plg: false,
            adaeror: [],
            sales_list: [],
        }
    },

    methods: {
        async fetchFilterData() {
			const [kantorRes, paketRes] = await Promise.all([
				axios.get('api/kantor/list-all'),
				axios.get('api/paket/list_ppoe')
			]);
			this.listKantor = kantorRes.data.data; // [{ id: 1, value: "Kantor A" }, ...]
			this.listPaket = paketRes.data.data;   // [{ id: 1, nama: "UpTo 20Mbps" }, ...]
		},
		async applyFilter() {
            this.loading = true;
            this.datas = [];
            this.ttl_data_pppoe = 0;
            try {
                const params = {
                    tipe: 1,
                    tampilankantor: this.tampilan_kantor,
                    kantor_id: this.filters.kantor_id,
                    paket_id: this.filters.paket_id,
                    nama: this.filters.nama,
					is_active:0
                };
                const [responseData, responseTotal] = await Promise.all([
                    axios.get('api/pppoe/list_nonaktif', { params }),
                    axios.get('api/pppoe/kontrak_count', { params })
                ]);
                this.datas = responseData.data.data;
                this.ttl_data_pppoe = parseInt(responseTotal.data.data ?? 0);

            } catch (error) {
                this.loading = false;
                console.error('Terjadi kesalahan saat memfilter data:', error);
            } finally {
                this.loading = false;
            }

        },
        clearFilter() {
            this.filters = {
                kantor_id: this.user.roles.id === 4 ? this.user.kantor_id : '',
                paket_id: '',
                nama: ''
            };
            this.tampilan_kantor = '10000';

            // Reset data
            this.datas = [];
            this.ttl_data_pppoe = 0;

            // Atau panggil ulang applyFilter jika ingin langsung ambil semua data
            this.applyFilter();
        },
        getBulan(tanggal) {
            var tgltemp = new Date(tanggal);
            var tahun = tgltemp.getFullYear();
            var bulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];

            return (bulan[tgltemp.getMonth()] + " " + tahun);
        },

        ubahTanggalTampill(e) {
            e.dialogs.save(this.inv_tanggal_batas);
        },

        ubahTanggalTampil(e) {
            e.dialog.save(this.inv_tanggal_query);
            this.inv_tanggal_tampil = this.getBulan(this.inv_tanggal_query);
        },

        tutupInvoiceManualModal() {
            this.adaeror = [];
            this.inv_no = "";
            this.inv_nama = "";
            $('#invoiceManualModal').modal('hide');
            this.$Progress.finish();
        },

        buatInvoiceManualModal(product) {
            this.adaeror = [];
            this.inv_tanggal_query = new Date().toISOString().substr(0, 7);
            this.inv_tanggal_batas = new Date(new Date().setFullYear(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10);
            this.inv_tanggal_tampil = this.getBulan(this.inv_tanggal_query);
            this.inv_no = product.id;
            this.inv_nama = product.nama;
            $('#invoiceManualModal').modal('show');
            this.$Progress.finish();
        },

        createInvoiceManual() {
            this.$Progress.start();
            let editFormData = new FormData();
            let dataUpdate = {};
            dataUpdate['inv_no'] = this.inv_no;
            dataUpdate['inv_tanggal_batas'] = this.inv_tanggal_batas;
            dataUpdate['inv_tanggal'] = this.inv_tanggal_query;
            editFormData.append('datanya', JSON.stringify(dataUpdate));
            axios.post('api/invoice/generateSolo', editFormData)
                .then((data) => {
                    if (data.data.success) {

                        Toast.fire({
                            icon: 'success',
                            title: data.data.message
                        });
                        this.tutupInvoiceManualModal();
                        this.$Progress.finish();
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: data.data.message ? data.data.message : "Error!. Try again later."
                        });

                        this.$Progress.fail();
                    }
                })
                .catch(e => {
                    Toast.fire({
                        icon: 'error',
                        title: e.response.data.data ? e.response.data.data : "Error!."
                    });
                    this.$Progress.fail();
                });

        },

        editNoKTP() {
            this.$Progress.start();
            let editFormData = new FormData();
            let dataUpdate = {};
            dataUpdate['id_lama'] = this.noktplama;
            dataUpdate['id_baru'] = this.noktpbaru;
            dataUpdate['id_inet'] = this.noinet;

            editFormData.append('datanya', JSON.stringify(dataUpdate));
            axios.post('api/pppoe/edit_ktp', editFormData)
                .then((data) => {
                    if (data.data.success) {

                        Toast.fire({
                            icon: 'success',
                            title: data.data.message
                        });
                        this.$Progress.finish();
                        this.loadProducts();
                        $('#editKTPModal').modal('hide');
                        closeEKTP();
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: data.data.data ? data.data.data : "Error!. Try again later."
                        });

                        this.$Progress.fail();
                    }
                })
                .catch(e => {
                    Toast.fire({
                        icon: 'error',
                        title: data.data.data ? data.data.data : "Error!."
                    });
                    this.$Progress.fail();
                });
        },

        editKTPModal(id, internet_id) {
            this.noktplama = id;
            this.noktpbaru = '';
            this.noinet = internet_id;
            $('#editKTPModal').modal('show');
        },

        closeEKTP() {
            this.noktplama = '';
            this.noktpbaru = '';
            this.noinet = '';
            this.editKTPAda = false;
            this.editKTPAdaNama = '';
        },

        toggleInternetCard() {
            this.$Progress.start();
            if (!this.form.showInternet) {
                this.form.showInternet = true;
            } else {
                this.form.showInternet = false;
            }
            this.$Progress.finish();
        },

        copyData(data) {
            const el = document.createElement('textarea');
            el.value = data;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            if (selected) {
                document.getSelection().removeAllRanges();
                document.getSelection().addRange(selected);
            }

            Toast.fire({
                icon: 'success',
                title: data + " Berhasil Dicopy"
            });
        },

        generateRandPass(length = 10) {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() *
                    charactersLength));
            }
            this.form.inet.password = result;
        },

        changeFixedBil() {
            if (this.form.inet.billing_period == 2) {
                this.fixedBil = true;
            } else {
                this.fixedBil = false;
            }
        },

        setTotal() {
            if (this.form.inet.ppn < 0 || this.form.inet.ppn === '') {
                this.form.inet.ppn = 0;
            }
            if (this.form.inet.diskon > 100) {
                this.form.inet.diskon = 100;
            } else if (this.form.inet.diskon < 0 || this.form.inet.diskon === '') {
                this.form.inet.diskon = 0;
            }

            if (this.harga) {
                this.ppn_dlm_rp = Math.round(parseFloat(this.harga * this.form.inet.ppn / 100));
                var hargappn = Math.round(parseFloat(this.harga) + parseFloat(this.harga * this.form.inet.ppn / 100));
                this.total = Math.round(parseFloat(hargappn - (hargappn * this.form.inet.diskon / 100)));
                //if(this.form.inet.tipe_langganan == '2'){
                if (this.form.inet.potong_kickback)
                    this.total = Math.round(parseFloat(this.total - this.form.inet.kickback));
                if (this.form.inet.potong_ppn)
                    this.total = Math.round(parseFloat(this.total - this.ppn_dlm_rp));
                if (this.form.inet.potong_pph23)
                    this.total = Math.round(parseFloat(this.total - this.form.inet.pph23));
                if (this.form.inet.potong_zakat)
                    this.total = Math.round(parseFloat(this.total - this.form.inet.zakat));
                this.form.total_checker = this.total;
            } else {
                this.total = 0;
                this.form.total_checker = this.total;
            }
        },

        preventArrow(e) {
            if (e.which === 38 || e.which === 40) {
                e.preventDefault();
            }
        },

        doLoadPaket() {
            this.form.inet.paket_id = '';
            this.harga = "0";
            this.total = "0";
            this.form.total_checker = this.total;
            this.ppn_dlm_rp = "0";
            this.form.inet.ppn = "0";
            this.form.inet.diskon = "0";
            this.form.inet.sla = "0";
            this.form.inet.kickback = "0";
            this.form.inet.pph23 = "0";
            this.form.inet.zakat = "0";
            this.form.inet.potong_ppn = false;
            this.form.inet.potong_pph23 = false;
            this.form.inet.potong_kickback = false;
            this.form.inet.potong_zakat = false;
            this.loadPakets();
        },

        tarukHarga(e) {
            this.harga = this.pakets[e]["harga"];
            this.setTotal();
        },

        reset_username() {
            this.form.username = '';
            this.form.inet.old_created_at = '';
        },

        reset_mac() {
            this.form.inet.mac_address = '';
        },

        reset_pool() {
            if (this.form.poolon) {
                this.form.inet.ip_address = '';
            } else {
                this.form.inet.pool_id = '';
            }
        },

        cobaEventCorp(e) {
            if (e.length) {
                this.table_group_state = true;
            } else {
                this.table_group_state = false;
            }
        },

        cobaEvent(e) {
            if (e.length) {
                this.table_group_state = true;
            } else {
                this.table_group_state = false;
            }
        },

        onUploadKTP(e) {
            this.filename = e.target.files[0].name;
            this.file_ktp = e.target.files[0];
            let reader = new FileReader();

            /*
            Add an event listener to the reader that when the file
            has been loaded, we flag the show preview as true and set the
            image to be what was read from the reader.
            */
            reader.addEventListener("load", function () {
                this.urlFotoKtp = reader.result;
                this.urlFotoKtpPreview = true;
            }.bind(this), false);

            /*
            Check to see if the file is not empty.
            */
            if (this.file_ktp) {
                /*
                    Ensure the file is an image file.
                */
                if (/\.(jpe?g|png|gif)$/i.test(this.filename)) {

                    /*
                    Fire the readAsDataURL method which will read the file in and
                    upon completion fire a 'load' event which we will listen to and
                    display the image in the preview.
                    */
                    reader.readAsDataURL(this.file_ktp);
                } else {
                    this.filename = "ERROR!";
                    this.file_ktp = "";
                    this.urlFotoKtp = "";
                    this.urlFotoKtpPreview = false;
                }
            } else {
                this.filename = "";
                this.file_ktp = "";
                this.urlFotoKtp = "";
                this.urlFotoKtpPreview = false;
            }
        },

        CariKTP2(e) {
            if (this.noktpbaru.length >= 16) {
                this.$Progress.start();
                // Make a request for a user with a given ID
                axios.get('api/pelanggan/search?q=' + escape(this.noktpbaru))
                    .then(response => {
                        // handle success
                        if (response.data.data) {
                            this.editKTPAda = true;
                            this.editKTPAdaNama = response.data.data.nama;
                        } else {
                            this.editKTPAda = false;
                        }
                    })
                    .catch(function (error) {
                        // handle error
                    })
                    .then(function () {
                        // always executed
                    });
                this.$Progress.finish();
            } else {
                this.editKTPAda = false;
            }
        },

        CariKTP(e) {
            if (e.target.value.length >= 16) {

                this.$Progress.start();
                // Make a request for a user with a given ID
                axios.get('api/pelanggan/search?q=' + escape(e.target.value))
                    .then(response => {
                        // handle success
                        if (response.data.data) {
                            this.setSelected(response.data.data);
                        } else {
                            this.setSelected(false);
                        }
                    })
                    .catch(function (error) {
                        // handle error
                    })
                    .then(function () {
                        // always executed
                    });
                this.$Progress.finish();
            } else {
                this.setSelected(false);
            }
        },

        setSelected(value) {
            if (value) {
                this.form.plg.nama = value.nama;
                this.form.plg.email = value.email;
                this.form.plg.hp = value.hp;
                this.form.plg.kabupaten_id = value.kabupaten_id;
                this.loadKecamatanTT(value.kabupaten_id);
                this.form.plg.kecamatan_id = value.kecamatan_id;
                this.form.plg.alamat = value.alamat;
                this.form.KTPAda = true;
                this.form.inet.sales_id = value.sales_id;
                this.disable_plg = true;
            } else {
                this.form.plg.nama = '';
                this.form.plg.email = '';
                this.form.plg.hp = '';
                this.form.plg.kabupaten_id = '';
                this.form.plg.kecamatan_id = '';
                this.form.plg.alamat = '';
                this.form.KTPAda = false;
                this.form.inet.sales_id = '';
                this.disable_plg = false;
            }
        },

        loadProducts() {
            if (this.$gate.isAllowed("is_pelanggan")) {
                if (this.$gate.dataType('1')) {
                    axios.get("api/pppoe/list_nonaktif?tipe=1&tampilankantor=" + this.tampilan_kantor).then(({ data }) => (this.datas = data.data));
                    axios.get("api/pppoe/kontrak_count?tipe=1&is_active=0").then(({ data }) => {
                        this.ttl_data_pppoe = parseInt(data.data ? data.data : 0);
                    });
                }
                if (this.$gate.dataType('2')) {
                    axios.get("api/pppoe/list_nonaktif?tipe=2&tampilankantor=" + this.tampilan_kantor).then(({ data }) => (this.datas_corp = data.data));

                }
            }
        },

        loadProvinsi(penampung) {
            axios.get("api/provinsi/list").then(({ data }) => (penampung = data.data));
        },

        loadKabupaten(id_prov) {
            axios.get("api/kabupaten/list?q=" + escape(id_prov)).then(({ data }) => (this.kabupatensTT = data.data));
        },

        loadKecamatanTT() {
            this.$Progress.start();
            axios.get("api/kecamatan/list?q=" + escape(this.form.plg.kabupaten_id)).then(({ data }) => (this.kecamatanTT = data.data));
            this.$Progress.finish();
        },

        loadKecamatanTI() {
            this.$Progress.start();
            axios.get("api/kecamatan/list?q=" + escape(this.form.inet.kabupaten_id)).then(({ data }) => (this.kecamatanTI = data.data));
            axios.get("api/kantor/list?q=" + escape(this.form.inet.kabupaten_id)).then(({ data }) => (this.kantorList = data.data));
            this.$Progress.finish();
        },

        loadPools() {
            axios.get("api/pool/list").then(({ data }) => (this.pools = data.data));
        },

        loadPakets() {
            axios.get("api/paket/list?tipe=" + this.form.inet.tipe_langganan).then(({ data }) => (this.pakets = data.data));
        },

        loadRouters() {
            axios.get("api/router/list").then(({ data }) => (this.routers = data.data));
        },


        editModal(product, editApa) {
            console.log(product);
            this.adaeror = [];
            this.filename = "";
            this.file_ktp = "";
            this.urlFotoKtp = "";
            this.urlFotoKtpPreview = false;
            this.harga = "0";
            this.total = "0";
            this.ppn_dlm_rp = "0";
            this.form.total_checker = this.total;
            this.$Progress.start();
            this.form.reset();
            this.form.showInternet = true;
            this.editmode = true;
            this.bolehedit = false;
            switch (editApa) {
                case "pelanggan":
                    this.editpelanggan = true;
                    break;
                case "internet":
                    this.editinternet = true;
                    break;
                default:
                    this.editAll = true;
                    break;
            }
            this.form.plg.id = product.pelanggan.id;
            this.form.plg.nama = product.pelanggan.nama;
            this.form.plg.email = product.pelanggan.email;
            this.form.plg.hp = product.pelanggan.hp;
            this.form.plg.provinsi_id = '1';
            this.form.plg.kabupaten_id = product.pelanggan.kabupaten_id;
            this.loadKecamatanTT(product.pelanggan.kabupaten_id);
            this.form.plg.kecamatan_id = product.pelanggan.kecamatan_id;
            this.form.plg.alamat = product.pelanggan.alamat;
            this.urlFotoKtp = product.pelanggan.url_ktp + '?skipcache=' + Date.now();;

            this.form.inet.id = product.id;
            this.form.username = product.username;
            this.form.inet.nama = product.nama;
            this.form.inet.provinsi_id = '1';
            this.form.inet.kabupaten_id = product.kabupaten_id;
            this.loadKecamatanTI(product.kabupaten_id);
            this.form.inet.kecamatan_id = product.kecamatan_id;
            this.form.inet.alamat = product.alamat;
            this.form.inet.latitude = product.latitude;
            this.form.inet.longitude = product.longitude;
            this.form.inet.tipe_langganan = product.tipe_langganan;
            this.loadPakets();
            this.form.inet.router_id = product.router_id;
            if (product.pool_id) {
                this.form.poolon = true;
                this.form.inet.pool_id = product.pool_id;
                this.form.inet.ip_address = '';
            } else {
                this.form.poolon = false;
                this.form.inet.ip_address = product.ip_address;
                this.form.inet.pool_id = '';
            }
            if (product.mac_address) {
                this.kunci_mac = true;
                this.form.inet.mac_address = product.mac_address;
            } else {
                this.kunci_mac = false;
                this.form.inet.mac_address = '';
            }
            this.form.inet.password = product.password;
            this.form.inet.snont = product.snont;
            this.form.inet.tipeont = product.tipeont;
            this.form.inet.kantor_id = product.kantor_id;
            this.form.inet.sla = product.sla ? product.sla : '0';
            this.form.inet.kickback = product.kickback ? product.kickback : '0';
            this.form.inet.pph23 = product.pph23 ? product.pph23 : '0';
            this.form.inet.zakat = product.zakat ? product.zakat : '0';
            this.form.inet.potong_ppn = product.potong_ppn ? product.potong_ppn : false;
            this.form.inet.potong_kickback = product.potong_kickback ? product.potong_kickback : false;
            this.form.inet.potong_zakat = product.potong_zakat ? product.potong_zakat : false;
            this.form.inet.potong_pph23 = product.potong_pph23 ? product.potong_pph23 : false;
            if (product.tipe_langganan == '1') {
                this.form.inet.is_prioritas = product.is_prioritas;
                this.form.inet.billing_tipe = product.billing_tipe;
                this.form.inet.billing_period = product.billing_period;
                if (product.billing_period == 1) {
                    this.form.inet.billing_mulai = product.billing_mulai;
                    this.form.inet.billing_akhir = product.billing_akhir;
                    this.fixedBil = false;
                } else {
                    this.form.inet.billing_mulai = '';
                    this.form.inet.billing_akhir = '';
                    this.fixedBil = true;
                }
                this.form.inet.paket_id = product.paket_id;
                this.form.inet.ppn = product.ppn ? product.ppn : 0;
                this.form.inet.diskon = product.diskon ? product.diskon : 0;
                //this.tarukHarga(product.paket_id);
                this.harga = product.paket.harga;
                this.setTotal();
            } else if (product.tipe_langganan == '2') {
                this.form.inet.paket_id = product.paket_id;
                this.form.inet.ppn = product.ppn ? product.ppn : 0;
                this.form.inet.diskon = product.diskon ? product.diskon : 0;
                this.form.inet.billing_period = '2';
                this.harga = product.paket.harga;
                this.setTotal();
            } else {

            }
            this.form.inet.sales_id = product.sales_id;
            $('#addNew').modal('show');
            this.$Progress.finish();
        },

        newModal() {
            this.adaeror = [];
            this.editmode = false;
            this.editpelanggan = false;
            this.editinternet = false;
            this.editall = false;
            this.disable_plg = false;
            this.form.KTPAda = false;
            this.bolehedit = false;
            this.filename = "";
            this.file_ktp = "";
            this.urlFotoKtp = "";
            this.harga = "0";
            this.total = "0";
            this.ppn_dlm_rp = "0";
            this.form.total_checker = this.total;
            this.urlFotoKtpPreview = false;
            this.form.reset();
            this.form.showInternet = false;
            this.generateRandPass();
            $('#addNew').modal('show');
        },

        createProduct() {
            this.$Progress.start();
            let formData = new FormData();
            formData.append('file', this.file_ktp);
            formData.append('datanya', JSON.stringify(this.form));
            const config = {
                headers: {
                    'content-type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
                }
            }
            axios.post('api/pppoe', formData, config)
                .then((data) => {
                    if (data.data.success) {
                        $('#addNew').modal('hide');

                        Toast.fire({
                            icon: 'success',
                            title: data.data.message
                        });
                        this.$Progress.finish();
                        this.loadProducts();
                        this.filename = "";
                        this.file_ktp = "";
                        this.urlFotoKtp = "";
                        this.urlFotoKtpPreview = false;
                        this.kunci_mac = false;

                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: data.data.data ? data.data.data : "Error!. Try again later."
                        });

                        this.$Progress.fail();
                    }
                })
                .catch(e => {
                    this.adaeror = e.response.data.errors;
                    if (this.adaeror) {
                        Toast.fire({
                            icon: 'error',
                            title: 'There are some Error in Input Field!'
                        });
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: 'Some error occured! Please try again'
                        });
                    }

                    this.$Progress.fail();
                })
        },

        updateProduct() {
            this.$Progress.start();
            let editFormData = new FormData();
            editFormData.append('datanya', JSON.stringify(this.form));
            editFormData.append('file', this.file_ktp);
            editFormData.append('_method', 'put');
            const config = {
                headers: {
                    'content-type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
                }
            }
            axios.post('api/pppoe/' + this.form.inet.id, editFormData, config)
                .then((data) => {
                    if (data.data.success) {
                        this.bolehedit = false;
                        $('#addNew').modal('hide');

                        Toast.fire({
                            icon: 'success',
                            title: data.data.message
                        });
                        this.$Progress.finish();
                        this.loadProducts();
                        this.filename = "";
                        this.file_ktp = "";
                        this.urlFotoKtp = "";
                        this.urlFotoKtpPreview = false;
                        this.kunci_mac = false;

                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: data.data.data ? data.data.data : "Error!. Try again later."
                        });

                        this.$Progress.fail();
                    }
                })
                .catch(e => {
                    this.adaeror = e.response.data.errors;
                    console.log(this.adaeror);
                    if (this.adaeror) {
                        Toast.fire({
                            icon: 'error',
                            title: this.adaeror
                        });
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: 'Some error occured! Please try again'
                        });
                    }

                    this.$Progress.fail();
                });
        },

        kickPengguna(id) {
            Swal.fire({
                title: 'Are you sure?',
                text: "Apakah Anda Yakin Untuk Melakukan Kick pada akun pelanggan?",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes!'
            }).then((result) => {

                // Send request to the server
                if (result.value) {
                    axios.post('api/pppoe/kick/' + id).then((data) => {
                        if (data.data.data) {
                            Swal.fire(
                                'Berhasil!',
                                'Pelanggan berhasil Disconnect.',
                                'success'
                            );
                        } else {
                            Swal.fire(
                                'Failed!',
                                data.data.message,
                                'warning'
                            );
                        }
                        this.loadProducts();
                    }).catch((data) => {
                        Swal.fire("Failed!", data.message, "warning");
                    });
                }
            })
        },

        aktifkanPengguna(id) {
            Swal.fire({
                title: 'Are you sure?',
                text: "Apakah Anda Yakin Untuk Mengaktifkan kembali pelanggan?",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    axios.post('api/pppoe/aktifkan/' + id).then((data) => {
                        if (data.data.data) {
                            Swal.fire(
                                'Berhasil!',
                                'Pelanggan berhasil Diaktifkan.',
                                'success'
                            );
                        } else {

                            Swal.fire(
                                'Failed!',
                                data.data.message,
                                'warning'
                            );
                        }
                        this.loadProducts();
                    }).catch((data) => {
                        Swal.fire("Failed!", data.message, "warning");
                    });
                }
            })
        },

        deleteProduct(id) {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {

                // Send request to the server
                if (result.value) {
                    axios.post('api/pppoe/' + id, { _method: 'delete' }).then((data) => {
                        if (data.data.data) {
                            Swal.fire(
                                'Deleted!',
                                'No internet Pelanggan has been deleted.',
                                'success'
                            );
                        } else {
                            Swal.fire(
                                'Failed!',
                                data.data.message,
                                'warning'
                            );
                        }
                        // Fire.$emit('AfterCreate');
                        this.loadProducts();
                    }).catch((data) => {
                        //console.log(data.data)
                        Swal.fire("Failed!", data.message, "warning");
                    });
                }
            })
        },

        loadSales() {
            axios.get("api/sales/list")
                .then(({ data }) => (this.sales_list = data.data))
                .catch(() => this.showErrorToast('Gagal memuat data sales.'));
        },
    },

    mounted: function () {
        this.$root.$on('myEvent', (text) => { // here you need to use the arrow function
            this.tampilan_kantor = text;
        })
        this.fetchFilterData();
        if (user.roles.id === 4) {
            this.filters.kantor_id = this.user.kantor_id;
        }
    },

    watch: {
        tampilan_kantor: function () {
            this.$Progress.start();
            this.loadProducts();
            this.$Progress.finish();
        }
    },

    created() {
        this.$Progress.start();
        this.loadProducts();
        this.loadKabupaten(1);
        this.loadPools();
        this.loadRouters();
        this.loadSales();
        this.$Progress.finish();
    },
}
</script>

<style src="vue-select/dist/vue-select.css"></style>
<style scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

img {
    height: auto;
    max-width: 2.5rem;
    margin-right: 1rem;
}

.d-center {
    display: flex;
    align-items: center;
}

.selected img {
    width: auto;
    max-height: 23px;
    margin-right: 0.5rem;
}

.v-select .dropdown li {
    border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
    border-bottom: none;
}

.v-select .dropdown li a {
    padding: 10px 20px;
    width: 100%;
    font-size: 1.25em;
    color: #3c3c3c;
}

.v-select .dropdown-menu .active>a {
    color: #fff;
}

/* The switch - the box around the slider */
.switch {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 17px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 13px;
    width: 13px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked+.slider {
    background-color: #2196F3;
}

input:focus+.slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked+.slider:before {
    -webkit-transform: translateX(13px);
    -ms-transform: translateX(13px);
    transform: translateX(13px);
}

.tanpawrap {
    white-space: nowrap;
}
</style>